import colors from '../theme/colors'

const colorsMatcher = {
  'Primary Blue': colors.primary.blue,
  'Primary Green': colors.primary.lime,
  Black: colors.unique.black,
  White: colors.unique.white,
  Grey: colors.primary.grey,
  'Secondary Purple': colors.secondary.purple,
  'Secondary Yellow': colors.secondary.yellow,
  'Secondary Pink': colors.secondary.pink,
  'Secondary Orange': colors.secondary.orange,
  'Secondary Red': colors.secondary.red,
}

export default colorsMatcher
